import React, { Component } from 'react'
import { connect } from 'react-redux';
import trans from 'trans'

import {
    updateInputValue as change,
} from "app/reducers/form"

import {
    css,
    Grid,
    GridCell,
    Icon,
    Section,
    Theme,
    InputGroup,
    Select,
    Checkbox,
    Paginator,
    FieldLabel,
} from "@bdfx/mergado-ui-kit"

import InpaintingMarker from 'template-edit/components/inpainting-marker';
import { getProductsForWatermarkGroupsFromFie, getProductsForWatermarkGroupsFromMergado, setInpaintingGroup } from 'app/helpers/api';
import { AxiosResponse } from 'axios';
import { ID, intboolean, ReduxList } from 'app/types/app-types';
import { renderWatermarkMask } from 'watermark-groups/watermark-groups-images';
import { getFormName, getSelectedAltLevels, NO_IMAGE_URL } from 'shape-edit/forms/helpers';
import { ALL_PRODUCTS_QUERY } from 'template-edit/forms/queries-form';
import { AlternativeTemplatesLevels, Query, Template } from 'app/types/model-types';
import { initProductsForWatermarks, ProductsForWatermarksType } from 'watermark-groups/watermark-groups-add-products';
import { ALL_POSITIONS, InpaintingGroupType, PositionType } from 'products/types';
import { find } from 'lodash';
import { URL } from 'app/config/api-config';
import { recalculateObjects } from 'products/components/render-objects-helper';
import InpaintingGroupSelect from 'template-edit/components/inpainting-group-select';
import { iconDisabledColor } from 'template-edit/components/tools-panel';
import { RandomProduct } from 'shape-edit/types';

interface Props {
    templateId: ID
    altTemplateId: ID
    isAlt: boolean
    randomProduct: RandomProduct
    alternativeTemplatesLevels: ReduxList<AlternativeTemplatesLevels>
    showAsModal: boolean
    queries: ReduxList<Query>
    templates: ReduxList<Template>
    inpaintingGroups: ReduxList<InpaintingGroupType[]>
    selectedGroupId: number
    setSelectedGroupId: Function
    setShowAsModal: Function
    updateInpaingGroups: Function
    change: typeof change,
}

interface State {
    showImagesFrom: 'fie' | 'mergado'
    page: number
    limit: number
    isLoading: boolean
    productsForPreview: ProductsForWatermarksType
    nonWorkingUrls: string[]
    productId: ID
    isAlt: boolean
    level: number
    imageOrAltId: ID
    imageOrAltUrl: string
    imageOrAltHash: string
    width: number
    height: number
    menuMaskExpanded: boolean
    menuHowToDealWithDiffSizeExpanded: boolean
    menuFiltersExpanded: boolean
    menuImagesExpanded: boolean
}

class InpaintingInEditor extends Component<Props, State> {
    constructor(props) {
        super(props);

        this.state = {
            showImagesFrom: 'fie',
            page: 1,
            limit: 10,
            isLoading: true,
            productsForPreview: initProductsForWatermarks,
            nonWorkingUrls: [],
            productId: null,
            imageOrAltId: null,
            imageOrAltUrl: null,
            imageOrAltHash: null,
            width: null,
            height: null,
            isAlt: null,
            level: null,
            menuMaskExpanded: true,
            menuHowToDealWithDiffSizeExpanded: true,
            menuFiltersExpanded: false,
            menuImagesExpanded: true,
        }
    }

    componentDidMount() {
        this.updatePreviewProducts(this.state.showImagesFrom, this.state.page, this.state.limit, initProductsForWatermarks.withMask, initProductsForWatermarks.withWatermarks, initProductsForWatermarks.templateId, initProductsForWatermarks.queryIds)
    }

    updatePreviewProducts = (showImagesFrom: 'fie' | 'mergado', page: number, limit: number, withMask: intboolean, withWatermarks: intboolean, templateId: ID, queryIds: string) => {
        const {isAlt, randomProduct} = this.props
        const a = getSelectedAltLevels()

        switch (showImagesFrom) {
            case 'fie':
                this.setState({ isLoading: true })

                getProductsForWatermarkGroupsFromFie(templateId, null, queryIds, page, limit, withMask, withWatermarks, isAlt, a?.levels, a?.mode, randomProduct?.id)
                    .then((response: AxiosResponse<ProductsForWatermarksType>) => {
                        const firstProduct = response.data.products && typeof response.data.products[0] !== 'undefined' ? response.data.products[0] : null
                        const firstExists = firstProduct && typeof firstProduct !== 'undefined'

                        this.setState({
                            productsForPreview: { ...response.data },
                            nonWorkingUrls: [],
                            imageOrAltUrl: firstExists ? firstProduct.image_or_alt_url : this.state.imageOrAltUrl,
                            imageOrAltId: firstExists ? firstProduct.image_or_alt_id : null,
                            imageOrAltHash: firstExists ? firstProduct.image_or_alt_hash : null,
                            productId: firstExists ? firstProduct.product_id : null,
                            width: firstExists ? firstProduct.width : this.state.width,
                            height: firstExists ? firstProduct.height : this.state.height,
                            isAlt: firstExists ? firstProduct.is_alt : this.state.isAlt,
                            level: firstExists ? firstProduct.level : this.state.level,
                        })
                    })
                    .catch(e => console.error('cannot get products', e))
                    .finally(() => this.setState({ isLoading: false }))
                break
            case 'mergado':
                this.setState({ isLoading: true })
                getProductsForWatermarkGroupsFromMergado(templateId, null, queryIds, page, limit, isAlt, a?.levels, a?.mode, randomProduct?.id)
                    .then((response: AxiosResponse<ProductsForWatermarksType>) => {
                        const firstProduct = response.data.products && typeof response.data.products[0] !== 'undefined' ? response.data.products[0] : null
                        const firstExists = firstProduct && typeof firstProduct !== 'undefined'
                        this.setState({
                            productsForPreview: { ...response.data },
                            nonWorkingUrls: [],
                            imageOrAltUrl: firstExists ? firstProduct.image_or_alt_url : this.state.imageOrAltUrl,
                            imageOrAltId: firstExists ? firstProduct.image_or_alt_id : null,
                            imageOrAltHash: firstExists ? firstProduct.image_or_alt_hash : null,
                            productId: firstExists ? firstProduct.product_id : null,
                            width: firstExists ? firstProduct.width : this.state.width,
                            height: firstExists ? firstProduct.height : this.state.height,
                        })
                    })
                    .catch(e => console.error('cannot get products', e))
                    .finally(() => this.setState({ isLoading: false }))
                break
            default:
                console.debug(`unknown source ${showImagesFrom}`)
                break
        }
    }

    transProductsCount = (count: number) => {
        if (count === 1) {
            return trans('one_product')
        } else if (count > 1 && count < 5) {
            return trans('less_than_five_products')
        } else {
            return trans('products_count')
        }
    }

    addNonWorkingUrl = (imageOrAltUrl: string) => {
        if (!this.state.nonWorkingUrls.includes(imageOrAltUrl)) {
            this.setState({ nonWorkingUrls: [...this.state.nonWorkingUrls, imageOrAltUrl] })
        }
    }

    renderPaginator = () => {
        const { productsForPreview, showImagesFrom, page, limit } = this.state

        return (productsForPreview && productsForPreview.totalProducts > 0) ?
            <Paginator
                showFirstAndLast={true}
                showPrevAndNext={false}
                maxLinks={3}
                labelFirst={`««`}
                labelPrevious={`«`}
                labelNext={`»`}
                labelLast={`»»`}
                currentPage={page}
                lastPage={Math.ceil(productsForPreview.totalProducts / limit)}
                onPageChange={(newPage) => {
                    this.setState({ page: newPage })
                    this.updatePreviewProducts(showImagesFrom, newPage, limit, productsForPreview.withMask, productsForPreview.withWatermarks, productsForPreview.templateId, productsForPreview.queryIds)
                }} /> :
            <span />
    }

    renderFilters = () => {
        const { showImagesFrom, productsForPreview, page, limit } = this.state
        const { templates, queries } = this.props

        const availableTemplates = (templates && templates.isLoaded && templates.data) ? templates.data.filter(t => t.active).map((t) => {
            return {
                label: `${t.name}`,
                value: `${t.id}`,
            }
        }) : null

        const availableQueries = (queries.isLoaded && queries.data) ? queries.data.map((q) => {
            return {
                label: `${q.id}: ${q.name === ALL_PRODUCTS_QUERY ? trans("all_products") : q.name} (${q.product_count})`,
                value: `${q.id}`,
            }
        }) : null

        return <div>
            {showImagesFrom === 'fie' &&
                <React.Fragment>
                    <div>
                        <Checkbox
                            key={`with_watermarks_${productsForPreview.withWatermarks}`}
                            value={productsForPreview.withWatermarks}
                            label={trans('has_watermark')}
                            onChange={(e) => {
                                this.setState({
                                    productsForPreview: {
                                        ...productsForPreview,
                                        withWatermarks: e,
                                    },
                                    page: 1
                                })
                                this.updatePreviewProducts(showImagesFrom, 1, limit, productsForPreview.withMask, e, productsForPreview.templateId, productsForPreview.queryIds)
                            }}
                        />

                        <Checkbox
                            key={`with_mask_${productsForPreview.withMask}`}
                            value={productsForPreview.withMask}
                            label={`${trans('with_objects')}`}
                            onChange={(e) => {
                                this.setState({
                                    productsForPreview: {
                                        ...productsForPreview,
                                        withMask: e,
                                    }, page: 1,
                                })
                                this.updatePreviewProducts(showImagesFrom, 1, limit, e, productsForPreview.withWatermarks, productsForPreview.templateId, productsForPreview.queryIds)
                            }}
                        />
                    </div>

                    {(availableTemplates && availableTemplates.length > 0) &&
                        <Select
                            value={productsForPreview?.templateId ? `${productsForPreview.templateId}` : ''}
                            options={availableTemplates}
                            label={trans('filter_template')}
                            onChange={(e) => {
                                const updated = {
                                    ...productsForPreview,
                                    templateId: e,
                                }
                                this.setState({ productsForPreview: updated, page: 1 })
                                this.updatePreviewProducts(showImagesFrom, 1, limit, updated.withMask, updated.withWatermarks, updated.templateId, updated.queryIds)
                            }}
                        />
                    }
                </React.Fragment>
            }

            {showImagesFrom === 'mergado' && (availableQueries && availableQueries.length > 0) &&
                <Select
                    value={productsForPreview?.queryIds || ''}
                    multiple={false}
                    closeOnChange={true}
                    options={availableQueries}
                    label={trans('queries')}
                    onChange={(e) => {
                        const updated = {
                            ...productsForPreview,
                            queryIds: e,
                        }
                        this.setState({ productsForPreview: updated, page: 1 })
                        this.updatePreviewProducts(showImagesFrom, 1, limit, updated.withMask, updated.withWatermarks, updated.templateId, updated.queryIds)
                    }}
                />
            }
        </div>
    }

    setGroup = (updatedGroup: InpaintingGroupType) => {
        setInpaintingGroup(updatedGroup)
            .then((response: AxiosResponse<{ group: InpaintingGroupType }>) => {
                this.props.updateInpaingGroups()
            })
            .catch(error => console.error('cannot update group', error))
    }

    renderSwitch = (transString: string, fieldName: string, icon: string): JSX.Element => {
        const val = this.state[fieldName]
        const newState = {}
        newState[fieldName] = !val
        return <Grid cols={'22px auto 32px'} gap={'4px'} style={{borderRadius: '10px', borderBottom: `1px solid ${val ? 'transparent' : '#cccccc26'}`}}>
            <GridCell><Icon type={icon} /></GridCell>
            <GridCell className='centering clickable' onClick={() => { this.setState({ ...newState }) }}><FieldLabel className='clickable'>{trans(transString)}</FieldLabel></GridCell>
            <GridCell className='centering clickable' onClick={() => { this.setState({...newState}) }}><Icon type={`chevron-${val ? 'down' : 'up'}`} size={18} color={val ? '#cccccc26' : iconDisabledColor} /></GridCell>
        </Grid>
    }

    render(): JSX.Element {
        const { showAsModal, selectedGroupId, inpaintingGroups, isAlt, randomProduct, templateId, altTemplateId } = this.props
        const { showImagesFrom, isLoading, productsForPreview, nonWorkingUrls, productId, level, imageOrAltId, imageOrAltUrl, imageOrAltHash, width, height } = this.state

        const selectedGroup : InpaintingGroupType = find(inpaintingGroups.data, (inpaintingGroup: InpaintingGroupType) => {
            return `${inpaintingGroup?.id}` === `${selectedGroupId}`
        })

        const formName = getFormName(isAlt)

        return (
            <React.Fragment>
                <GridCell></GridCell>
                <GridCell>
                    <StyledDiv>
                        <StyledSection id={'section-container'}>
                            <StyledModalLikeDiv dataIsModal={showAsModal}>
                                <div style={{ fontSize: 'large', textAlign: 'center', paddingTop: '20px' }}>
                                    {trans('inpainting_create_mask')}
                                </div>

                                <MaskAndPreviewsGrid>
                                    <GridCell>
                                        <InpaintingMarker
                                            productId={productId}
                                            templateId={templateId}
                                            altTemplateId={altTemplateId}
                                            isAlt={isAlt}
                                            altLevel={level}
                                            imageOrAltId={imageOrAltId}
                                            imageOrAltUrl={imageOrAltUrl}
                                            imageOrAltHash={imageOrAltHash}
                                            width={width}
                                            height={height}
                                            selectedGroup={selectedGroup}
                                            close={() => this.props.setShowAsModal(this.props.showAsModal === false ? null : false)}
                                            updateInpaintingGroups={this.props.updateInpaingGroups}
                                            changeGroupId={(value: ID) => {
                                                this.props.change(formName, 'inpainting_group_id', value)
                                                this.props.updateInpaingGroups()
                                            }}
                                        />
                                    </GridCell>
                                    <GridCell>
                                        {showAsModal &&
                                            <React.Fragment>
                                                {this.renderSwitch('watermark_mask', 'menuMaskExpanded', 'paw')}
                                                {this.state.menuMaskExpanded &&
                                                    <InpaintingGroupSelect close={() => this.setState({ menuMaskExpanded: false })} />
                                                }
                                            </React.Fragment>
                                        }

                                        {selectedGroup &&
                                            <React.Fragment>
                                                {this.renderSwitch('inpainting_how_to_deal_with_diff_size', 'menuHowToDealWithDiffSizeExpanded', 'settings-light')}

                                                {this.state.menuHowToDealWithDiffSizeExpanded &&
                                                    <React.Fragment>
                                                        <StyledInputGroup
                                                            key={'pos_relative_to'}
                                                            singleChoice={true}
                                                            hideInput={true}
                                                            onChange={(value) => {
                                                                this.setGroup({
                                                                    ...selectedGroup,
                                                                    pos_relative_to: value === 'position_relative_to' ? (selectedGroup.pos_relative_to ? selectedGroup.pos_relative_to : 'bottomleft') : null
                                                                })
                                                            }}
                                                            value={selectedGroup.pos_relative_to ? 'position_relative_to' : 'scale_mask_to_image_size'}
                                                            items={[
                                                                { value: 'position_relative_to', label: `${trans('position_relative_to')} ...` },
                                                                { value: 'scale_mask_to_image_size', label: trans('scale_mask_to_image_size') },
                                                            ]}
                                                        />

                                                        {!!selectedGroup.pos_relative_to &&
                                                            <React.Fragment>
                                                                <Grid cols={'auto max-content auto'} style={{ marginBottom: '20px' }}>
                                                                    <GridCell></GridCell>
                                                                    <GridCell>
                                                                        <PositionsGrid>
                                                                            {ALL_POSITIONS.map((position: PositionType) => <GridCell
                                                                                key={position}
                                                                                onClick={() => this.setGroup({
                                                                                    ...selectedGroup,
                                                                                    pos_relative_to: position
                                                                                })}>
                                                                                <img src={`${URL.publicPath}img/icons/position-${position}.svg`} className={selectedGroup.pos_relative_to === position ? 'active' : undefined} />
                                                                            </GridCell>
                                                                            )}
                                                                        </PositionsGrid>
                                                                    </GridCell>
                                                                    <GridCell></GridCell>
                                                                </Grid>

                                                                <Checkbox
                                                                    value={selectedGroup.scale_objects}
                                                                    onChange={(value) => {
                                                                        this.setGroup({
                                                                            ...selectedGroup,
                                                                            scale_objects: value ? 1 : 0,
                                                                        })
                                                                    }}
                                                                    label={trans('scale_to_size')}
                                                                    onValue={1}
                                                                    offValue={0}
                                                                />
                                                            </React.Fragment>
                                                        }
                                                    </React.Fragment>
                                                }
                                            </React.Fragment>
                                        }

                                        {this.renderSwitch('previews', 'menuImagesExpanded', 'eye')}
                                        {this.state.menuImagesExpanded &&
                                            <React.Fragment>
                                                <ImagesGrid className={isLoading ? 'muk-helper-loading' : ''}>
                                                    {productsForPreview.products && productsForPreview.products
                                                        .map(product => {
                                                            const isBadUrl = nonWorkingUrls.includes(product.image_or_alt_url)
                                                            const productIdInfo = product.product_id ? ` (mergado product ${product.product_id})` : ''

                                                            const recalculatedObjects: string = recalculateObjects(selectedGroup, product.width, product.height)

                                                            return <GridCell
                                                                key={`inpainting_products_${product.product_id}_${nonWorkingUrls.length}_${selectedGroup?.mask_hash}`}
                                                                className='clickable'
                                                                onClick={() => {
                                                                    const img = new Image()
                                                                    img.src = product.image_or_alt_url
                                                                    img.onload = () => {
                                                                        this.setState({
                                                                            imageOrAltUrl: product.image_or_alt_url,
                                                                            imageOrAltId: product.image_or_alt_id,
                                                                            productId: product.product_id,
                                                                            width: img.width,
                                                                            height: img.height,
                                                                        })

                                                                        console.debug(`changing to new product ${this.state.width}x${this.state.height} --> ${product.width}x${product.height} and recalculating objects`)
                                                                        this.setGroup({
                                                                            ...selectedGroup,
                                                                            user_set_objects: recalculatedObjects,
                                                                            width: product.width,
                                                                            height: product.height
                                                                        })
                                                                    }
                                                                }}>

                                                                {recalculatedObjects ?
                                                                    renderWatermarkMask({ ...product, user_set_objects: recalculatedObjects }, product.image_or_alt_url) :
                                                                    <img
                                                                        className={`${!isBadUrl ? 'checker' : 'bad-url'}`}
                                                                        src={product.image_or_alt_url}
                                                                        title={`${product.image_or_alt_url}${productIdInfo} ${product.width}x${product.height}`}
                                                                        onError={(e) => {
                                                                            if (e.currentTarget.src !== NO_IMAGE_URL) {
                                                                                this.addNonWorkingUrl(product.image_or_alt_url)
                                                                                e.currentTarget.src = NO_IMAGE_URL
                                                                            }
                                                                        }}
                                                                    />
                                                                }

                                                                <div style={{ fontSize: 'small', color: iconDisabledColor }}>{product.width}x{product.height}</div>
                                                            </GridCell>
                                                        })
                                                    }
                                                </ImagesGrid>


                                                {this.renderSwitch('filter', 'menuFiltersExpanded', 'filter')}
                                                {this.state.menuFiltersExpanded &&
                                                    <React.Fragment>
                                                        <InputGroup
                                                            singleChoice={true}
                                                            hideInput={true}
                                                            onChange={(value) => {
                                                                this.setState({
                                                                    showImagesFrom: value,
                                                                    page: 1
                                                                })
                                                                this.updatePreviewProducts(
                                                                    value,
                                                                    1,
                                                                    this.state.limit,
                                                                    initProductsForWatermarks.withMask,
                                                                    initProductsForWatermarks.withWatermarks,
                                                                    initProductsForWatermarks.templateId,
                                                                    initProductsForWatermarks.queryIds
                                                                )
                                                            }}
                                                            value={showImagesFrom}
                                                            items={[
                                                                { value: 'fie', label: trans('images_from_fie') },
                                                                { value: 'mergado', label: trans('images_from_mergado') },
                                                            ]}
                                                            style={{ margin: '20px 0px 0px 0px', width: '100%' }}
                                                        />

                                                        <div style={{ marginTop: '20px' }}>
                                                            {this.renderFilters()}
                                                        </div>

                                                        <div style={{ marginTop: '20px' }}>
                                                            {this.renderPaginator()}
                                                        </div>
                                                    </React.Fragment>
                                                }
                                            </React.Fragment>
                                        }
                                    </GridCell>
                                </MaskAndPreviewsGrid>
                            </StyledModalLikeDiv>
                        </StyledSection>
                    </StyledDiv>
                </GridCell>
            </React.Fragment>
        )
    }
}

const StyledDiv = css('div')({
    marginRight: '15px',
    marginTop: '55px',
})

const StyledSection = css(Section)({
    overflow: 'visible',
    height: 'calc(100vh - 160px)',
    overflowY: 'auto',
})

const MaskAndPreviewsGrid = css(Grid)({
    gridTemplateColumns: 'auto 260px',
    gridGap: '20px',
    width: '100%',
    minHeight: 'calc(100vh - 280px)',
    overflowY: 'auto',
    padding: '10px',
})

const StyledInputGroup = css(InputGroup)({
    margin: '20px 0px',
    width: '100%',
})

const ImagesGrid = css(Grid)({
    marginTop: '20px',
    maxHeight: '50vh',
    overflowX: 'auto',
    gridTemplateRows: '1fr 1fr',
    gridAutoFlow: 'column',
    gridGap: '25px',
    ' .muk-gridcell': {
        textAlign: 'center',
        alignSelf: 'center',
    },
    ' img, svg': {
        maxWidth: '100%',
        maxHeight: '100px',
    }
})

const PositionsGrid = css(Grid)({
    gridTemplateColumns: 'repeat(3, 60px)',
    ' .muk-gridcell': {
        alignSelf: 'center',
        textAlign: 'center',
        cursor: 'pointer',
    },
    ' img': {
        border: '3px solid transparent'
    },
    ' img.active': {
        border: `3px solid ${Theme.steelblue}`
    }
})

const StyledModalLikeDiv = css('div')({
    margin: '10px',
    ' .title': {
        textAlign: 'center',
        alignSelf: 'center',
        fontSize: '1.4em',
        overflow: 'hidden',
    },
    ' .modal': {
        paddingTop: '20px',
    },
    ' .error': {
        fontSize: 'small',
        fontStyle: 'italic',
        color: Theme.red,
        marginTop: '5px',
    }
}, props => (props.dataIsModal ? {
    position: 'fixed',
    top: '40px',
    left: '0px',
    borderRadius: '6px',
    background: '#ffffff',
    width: 'calc(100% - 20px)',
    /* minHeight: '90%', */
    maxHeight: 'calc(100vh - 80px)',
    zIndex: 409,
    border: '1px solid #dbdbdb',
    boxShadow: '0 0 30px 1px rgba(0,0,0,.3)',
    webkitBoxShadow: '0 0 30px 1px rgba(0,0,0,.3)',
    mozBoxShadow: '0 0 30px 1px rgba(0,0,0,.3)',
} : {})
)

function mapStateToProps(state) {
    return {
        isAlt: state.isAlt,
        queries: state.queries,
        templates: state.templates,
        inpaintingGroups: state.inpaintingGroups,
        alternativeTemplatesLevels: state.alternativeTemplatesLevels,
        randomProduct: state.randomProduct,
    }
}

export default connect(mapStateToProps, {
    change,
})(InpaintingInEditor)
